export interface NdaaData {
  drones: { id: string; name: string; callsign: string; manufacturer: string; model: string; is_ndaa_compliant: boolean }[];
  compliant: number;
  total: number;
}

export interface ActivityLog {
  id: string;
  action: string;
  entity_type: string | null;
  user_name: string | null;
  user_email: string | null;
  metadata: Record<string, unknown>;
  created_at: string;
}

export interface MaintenanceRecord {
  id: string;
  drone_callsign: string;
  type: string;
  description: string;
  performed_at: string;
  next_maintenance_at: string | null;
}

export type PredictionStatus = 'overdue' | 'due_soon' | 'ok';

export interface MaintenancePrediction {
  drone_id: string;
  drone_callsign: string;
  type: string;
  hours_since_last: number;
  threshold_hours: number;
  status: PredictionStatus;
  hours_until_due: number;
}

export interface TakStatusPayload {
  multicast: { enabled: boolean; address: string | null; port: number };
}

export function maintenanceTypeLabel(t: string): string {
  const map: Record<string, string> = {
    propeller_check: 'Propeller check',
    full_inspection: 'Full inspection',
    firmware_check: 'Firmware check',
    battery_replacement: 'Battery replacement',
  };
  return map[t] || t.replace(/_/g, ' ');
}

export function formatDtg(iso: string): string {
  const d = new Date(iso);
  const day = String(d.getUTCDate()).padStart(2, '0');
  const hours = String(d.getUTCHours()).padStart(2, '0');
  const mins = String(d.getUTCMinutes()).padStart(2, '0');
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  return `${day} ${hours}${mins}Z ${months[d.getUTCMonth()]} ${String(d.getUTCFullYear()).slice(-2)}`;
}

export function timeAgo(iso: string): string {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}
